import React, { useState, useEffect, useMemo } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const shuffleArray = (array) => {
    let currentIndex = array.length, randomIndex;
    const newArray = [...array]; // Work on a copy

    while (currentIndex != 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [newArray[currentIndex], newArray[randomIndex]] = [newArray[randomIndex], newArray[currentIndex]];
    }
    return newArray;
};

export default function MissingNew({ v, onChange, showAnswers, student_answer }) {

    
    const [htmlContent, setHtmlContent] = useState(v?.answers?.text || '');
    const [words, setWords] = useState(v?.answers?.words || []);
    const [userAnswers, setUserAnswers] = useState(student_answer || Array(v?.answers?.words?.length).fill(null));

    function handleHtmlChange() {
        userAnswers?.forEach((word, index) => {
            // 1. Select the specific element for this index
            const elements = document.querySelectorAll('.answerBoxMissing.active .hiddenTextQuestion');
            const targetElement = elements[index];

            // console.log(targetElement);
            
            if (targetElement) {
                // 2. Clear existing content to prevent stacking duplicates
                const wordToRemove = targetElement.querySelector('.dropped-word');
        
                // 3. Remove it if it exists
                if (wordToRemove) {
                    wordToRemove.remove();
                }

                // 3. Only insert if a word exists in the state
                if (word) {
                    // Using a template literal to insert your structured HTML
                    targetElement.insertAdjacentHTML('beforeend', `<b class="dropped-word"><a data-index="${index}" class='remove-word'>x</a>${word}</b>`);
                }
            }
        });
    }

    function sendAnswer() {

        
        let result = true;
        let ck = userAnswers?.filter(v => v == null);
        if (ck?.length) {
            result = false;
        }

        for (let i = 0; i < v?.answers?.words.length; i++) {
            if (userAnswers[i] !== v?.answers?.words[i]) result = false;
        }
        
        if (typeof onChange !== 'undefined') onChange({ ID: v?.ID, answer: userAnswers, right: result });
    }

    function handleContainerClick(e) {
        if (student_answer) return false;
        if (e.target.classList.contains('remove-word')) {
            const index = e.target.getAttribute('data-index');
            setUserAnswers(prevAnswers => {
                const newAnswers = [...prevAnswers];
                newAnswers[index] = null;
                return newAnswers;
            });
        }
        
    }
    
    const handleDragStart = (e, word) => {
        e.dataTransfer.setData("text/plain", word);
    };

    // 2. Allow dropping
    const handleDragOver = (e) => {
        e.preventDefault(); // Required to allow drop
    };

    // 3. Handle the drop
    const handleDrop = (e) => {
        if (student_answer) return false;
        e.preventDefault();
        const word = e.dataTransfer.getData("text/plain");
        
        let releaseDrag = e?.target?.classList?.contains('hiddenTextQuestion');
        if (!releaseDrag) {
            return false;
        }

        const allTargets = document.querySelectorAll('.hiddenTextQuestion');
        const index = Array.from(allTargets).indexOf(e.target);
        
        // Remove the word from the list
        setUserAnswers(prevAnswers => {
            const newAnswers = [...prevAnswers];
            newAnswers[index] = word; // Set the word at this index
            return newAnswers;
        });
    };

    useEffect(() => {
        
        handleHtmlChange();
        sendAnswer();
        
    }, [userAnswers]);
    
    useEffect(() => {
        
        if (student_answer) {
            setUserAnswers(student_answer);
        } else {
            if (showAnswers) {
                setUserAnswers(v?.answers?.words);
            } else {
                setUserAnswers(Array(v?.answers?.words?.length).fill(null));
            }
        }
        
    }, [showAnswers]);
    
    
    const shuffledWords = useMemo(() => shuffleArray(v?.answers?.words || []), [v?.answers?.words]);
    
    return (
        <div className="answerBoxMissing active">
            <div onDragOver={handleDragOver} onClick={handleContainerClick} onDrop={handleDrop} className="missingTxt" dangerouslySetInnerHTML={{__html: htmlContent}}></div>

            {!student_answer ? <ul className='missingWordKeysList'>
                {shuffledWords?.map((v, k) => {
                    if (!userAnswers.includes(v)) {
                        return (
                            <li onDragStart={(e) => handleDragStart(e, v)} draggable={true} key={k}>{v}</li>
                        );
                    }
                })}
            </ul>: false}
        </div>
    );

}
